import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const reviewsRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'reviews-list',
    component: () => import('src/pages/settings/ReviewsListPage.vue'),
  },
];

// Public iframe-embeddable reviews widget (offices subdomain).
export const embedReviewsRoutes: RouteRecordRaw[] = [
  {
    path: '/embed/reviews',
    component: () => import('layouts/EmbedLayout.vue'),
    meta: { public: true },
    children: [
      {
        path: '',
        name: 'embed-reviews',
        component: () => import('pages/embed/ReviewsEmbedPage.vue'),
      },
    ],
  },
];

export const settingsTemplateRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'templates',
    component: () => import('src/pages/settings/TemplatesPage.vue'),
  },
  {
    path: 'new',
    alias: $gettext('nova'),
    name: 'new-template',
    props: (route) => ({
      next: route.query.next,
    }),
    component: () => import('src/pages/settings/CreateTemplatePage.vue'),
  },
  {
    path: 'edit/:templateId',
    alias: $gettext('upravit') + '/:templateId',
    name: 'update-template',
    props: (route) => ({
      templateId: route.params.templateId,
      next: route.query.next,
    }),
    component: () => import('src/pages/settings/UpdateTemplatePage.vue'),
  },
];
